import { StorageName } from "../../enum/common-enum";

export class TotalSectionModel {
  showPreviousBalance: boolean=true;
  isReturn: boolean=true;
  isAdditional_Amt: boolean=true;
  isGen_Reward_Pt_Amt: boolean=true;
  isDiscount: boolean=true;
  isRedeem_Pt: boolean=true;
  isRedeem_Pt_Balance: boolean=true;
  isRound_Off_For_GrandTotal: boolean=true;
  isRound_Off_For_NetTotal: boolean=true;
  isCurrency_Exchange: boolean=true;
  isReturn_Invoice: boolean=true;
  isPaid_Amt: boolean=true;
  isBalance_Amt: boolean=true;
  isStock_In: boolean=true;
  isCrediNote_Amt : boolean = false;
  isDiscount_Amt : boolean = false;
  isGrandTotal : boolean = true;
  isNetTotal  : boolean = true;
  isLineVisible : boolean = true;
  isAdvancePayment : boolean = true;
  isMetalAmmount: boolean = true;
  isHideTotal: boolean = false;
  isEstimate_Amount : boolean = false;
  isFinal_Amount : boolean = false;
  isLoan_Amount : boolean = false;
  is_Estimate_Percent : boolean = false;

  setVisibility(storageName :any)
  {
    switch(storageName)
    {
      case StorageName.FORMNAME_TRANSACTION_SALESINVOICE:
      case StorageName.FORMNAME_TRANSACTION_REPAIRINVOICE:
        this.isStock_In = false;
        break;
      case StorageName.FORMNAME_TRANSACTION_PURCHASEINVOICE:
      case StorageName.FORMNAME_TRANSACTION_PURCHASEQUOTATION:
      case StorageName.FORMNAME_TRANSACTION_JOBWORKINVOICE:
        this.isRedeem_Pt = false;
        this.isRedeem_Pt_Balance = false;
        this.isGen_Reward_Pt_Amt = false;
        break;
      case StorageName.FORMNAME_TRANSACTION_OLDJEWELRY_SCRAPINVOICE:
        this.isRedeem_Pt = false;
        this.isRedeem_Pt_Balance = false;
        this.isGen_Reward_Pt_Amt = false;
        this.isReturn_Invoice = false;
        break;
      case StorageName.FORMNAME_TRANSACTION_SALESRETURN:
        this.isReturn = false;
        this.isAdditional_Amt = false;
        this.isGen_Reward_Pt_Amt = false;
        this.isDiscount = false;
        this.isRedeem_Pt = false;
        this.isRedeem_Pt_Balance = false;
        this.isRound_Off_For_GrandTotal = true;
        this.isRound_Off_For_NetTotal = false;
        this.isCurrency_Exchange = true;
        this.isReturn_Invoice = false;
        this.isPaid_Amt = false;
        this.isBalance_Amt = false;
        this.isStock_In = false;
        this.isCrediNote_Amt = true;
        this.isDiscount_Amt = false;
        this.isGrandTotal = false;
        this.isMetalAmmount=false;
        this.isNetTotal = false;
        this.isAdvancePayment= false;
        this.isLineVisible = false;
        break;
        case StorageName.FORMNAME_TRANSACTION_PURCHASERETURN:
        this.isReturn = false;
        this.isAdditional_Amt = false;
        this.isGen_Reward_Pt_Amt = false;
        this.isDiscount = false;
        this.isRedeem_Pt = false;
        this.isRedeem_Pt_Balance = false;
        this.isRound_Off_For_GrandTotal = true;
        this.isRound_Off_For_NetTotal = false;
        this.isCurrency_Exchange = true;
        this.isReturn_Invoice = false;
        this.isPaid_Amt = false;
        this.isBalance_Amt = false;
        this.isStock_In = false;
        this.isCrediNote_Amt = true;
        this.isDiscount_Amt = false;
        this.isGrandTotal = false;
        this.isMetalAmmount=false;
        this.isNetTotal = false;
        this.isAdvancePayment= false;
        this.isLineVisible = false;
        break;
      case StorageName.FORMNAME_ORDERS_SALESORDER:
      case StorageName.FORMNAME_ORDERS_REPAIRORDER:
        this.isReturn = false;
        this.isGrandTotal = true;
        this.isAdditional_Amt = false;
        this.isGen_Reward_Pt_Amt = false;
        this.isDiscount = false;
        this.isRedeem_Pt = false;
        this.isRedeem_Pt_Balance = false;
        this.isRound_Off_For_GrandTotal = true;
        this.isRound_Off_For_NetTotal = false;
        this.isCurrency_Exchange = false;
        this.isReturn_Invoice = false;
        this.isPaid_Amt = true;
        this.isBalance_Amt = true;
        this.isStock_In = false;
        this.isCrediNote_Amt = false;
        this.isDiscount_Amt = false;
        this.isNetTotal = false;
        this.isAdvancePayment= false;
        this.isLineVisible = false;
        break;
        case StorageName.FORMNAME_TRANSACTION_CONSIGNMENTIN:
          case StorageName.FORMNAME_TRANSACTION_CONSIGNMENTOUT:
          this.isAdditional_Amt = false;
          this.isNetTotal = false;
          this.isAdvancePayment= false;
          this.isGen_Reward_Pt_Amt = false;
          this.isDiscount = false;
          this.isRedeem_Pt = false;
          this.isRedeem_Pt_Balance = false;
          this.isLineVisible = false;
          break;
      case StorageName.FORMNAME_TRANSACTION_EXPENSES:
          this.isReturn = false;
          this.isAdditional_Amt = false;
          this.isGen_Reward_Pt_Amt = false;
          this.isDiscount = true;
          this.isRedeem_Pt = false;
          this.isRedeem_Pt_Balance = false;
          this.isRound_Off_For_GrandTotal = true;
          this.isRound_Off_For_NetTotal = false;
          this.isCurrency_Exchange = false;
          this.isReturn_Invoice = false;
          this.isPaid_Amt = true;
          this.isBalance_Amt = true;
          this.isStock_In = false;
          this.isCrediNote_Amt = true;
          this.isDiscount_Amt = false;
          this.isGrandTotal = true;
          this.isNetTotal = true;
          this.isLineVisible = true;
          this.isCrediNote_Amt = false;
          this.isAdvancePayment= false;
          this.isMetalAmmount=false;
          this.isLineVisible=false;
      break;
      case StorageName.FORMNAME_TRANSACTION_NEW_LOAN:
        this.isHideTotal = true;
        this.isAdditional_Amt = false;
        this.isNetTotal = false;
        this.isGen_Reward_Pt_Amt = false;
        this.isDiscount = false;
        this.isRedeem_Pt = false;
        this.isRedeem_Pt_Balance = false;
        this.isLineVisible = false;
        this.isEstimate_Amount = true;
        this.isReturn_Invoice = false;
        this.isRound_Off_For_NetTotal = false;
        this.isRound_Off_For_GrandTotal = false;
        this.isPaid_Amt = false;
        this.isBalance_Amt = false;
        this.isCurrency_Exchange = false;
        this.isGrandTotal = false;
        this.isLoan_Amount = true;
        this.isFinal_Amount = true;
        this.is_Estimate_Percent = true;
        break;
        case StorageName.FORMNAME_PRODUCT_ADD_APPRAISAL:
          this.isAdditional_Amt = false;
          this.isNetTotal = false;
          this.isAdvancePayment= false;
          this.isGen_Reward_Pt_Amt = false;
          this.isDiscount = false;
          this.isRedeem_Pt = false;
          this.isRedeem_Pt_Balance = false;
          this.isLineVisible = false;
          this.isMetalAmmount = false;
          this.isRound_Off_For_GrandTotal = false;
          this.isReturn_Invoice = false;
          this.isPaid_Amt = false;
           this.isBalance_Amt = false;
          break;
        case StorageName.FORMNAME_TRANSACTION_RECEIPTVOUCHER:
        case StorageName.FORMNAME_TRANSACTION_PAYMENTVOUCHER:
          this.isHideTotal = true;
          this.isAdditional_Amt = false;
          this.isNetTotal = false;
          this.isGen_Reward_Pt_Amt = false;
          this.isDiscount = false;
          this.isRedeem_Pt = false;
          this.isRedeem_Pt_Balance = false;
          this.isLineVisible = false;
          this.isEstimate_Amount = false;
          this.isReturn_Invoice = false;
          this.isRound_Off_For_NetTotal = false;
          this.isRound_Off_For_GrandTotal = false;
          this.isPaid_Amt = false;
          this.isBalance_Amt = false;
          this.isCurrency_Exchange = false;
          this.isGrandTotal = false;
          this.isLoan_Amount = false;
          this.isFinal_Amount = false;
          this.is_Estimate_Percent = false;
          this.isAdvancePayment = false;
          this.isMetalAmmount = false;
          break;
          case StorageName.FORMNAME_ORDERS_CATALOGUE_QUOTATION:
            this.isAdditional_Amt = false;
            this.isNetTotal = false;
            this.isAdvancePayment= false;
            this.isGen_Reward_Pt_Amt = false;
            this.isDiscount = false;
            this.isRedeem_Pt = false;
            this.isRedeem_Pt_Balance = false;
            this.isLineVisible = false;
            this.isMetalAmmount = false;
            this.isRound_Off_For_GrandTotal = false;
            this.isReturn_Invoice = false;
            this.isPaid_Amt = false;
             this.isBalance_Amt = false;
            break;
            case StorageName.FORMNAME_TRANSACTION_SALEFIXINGDIRECTINVOICE:
              this.isAdditional_Amt = false;
              this.isNetTotal = false;
              this.isAdvancePayment= false;
              this.isGen_Reward_Pt_Amt = false;
              this.isDiscount = false;
              this.isRedeem_Pt = false;
              this.isRedeem_Pt_Balance = false;
              this.isLineVisible = false;
              this.isMetalAmmount = false;
              this.isRound_Off_For_GrandTotal = false;
              this.isReturn_Invoice = false;
              this.isPaid_Amt = false;
               this.isBalance_Amt = false;
               this.isGrandTotal= false;
               this.isHideTotal= true;
              break;
              case StorageName.FORMNAME_TRANSACTION_PURCHASEFIXINGDIRECTINVOICE:
                this.isAdditional_Amt = false;
                this.isNetTotal = false;
                this.isAdvancePayment= false;
                this.isGen_Reward_Pt_Amt = false;
                this.isDiscount = false;
                this.isRedeem_Pt = false;
                this.isRedeem_Pt_Balance = false;
                this.isLineVisible = false;
                this.isMetalAmmount = false;
                this.isRound_Off_For_GrandTotal = false;
                this.isReturn_Invoice = false;
                this.isPaid_Amt = false;
                this.isBalance_Amt = false;
                this.isGrandTotal= false;
                this.isHideTotal= true;
                break;
                case StorageName.FORMNAME_TRANSACTION_INCOMEINVOICE:
                  this.isReturn = false;
                  this.isAdditional_Amt = false;
                  this.isGen_Reward_Pt_Amt = false;
                  this.isDiscount = true;
                  this.isRedeem_Pt = false;
                  this.isRedeem_Pt_Balance = false;
                  this.isRound_Off_For_GrandTotal = true;
                  this.isRound_Off_For_NetTotal = false;
                  this.isCurrency_Exchange = false;
                  this.isReturn_Invoice = false;
                  this.isPaid_Amt = true;
                  this.isBalance_Amt = true;
                  this.isStock_In = false;
                  this.isCrediNote_Amt = true;
                  this.isDiscount_Amt = false;
                  this.isGrandTotal = true;
                  this.isNetTotal = true;
                  this.isLineVisible = true;
                  this.isCrediNote_Amt = false;
                  this.isAdvancePayment= false;
                  this.isMetalAmmount=false;
                  this.isLineVisible=false;
              break;
    }

    
  }
}